import React, { Component } from 'react';
import styled from 'styled-components';
import { getTheme } from '../../global/utils';
import CardFile from '../../components/cards/CardFile';
import Heading from '../../components/text/Heading';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChartLine, faTrashAlt } from '@fortawesome/pro-light-svg-icons';
import { faPencil } from '@fortawesome/pro-solid-svg-icons';
import Button from '../../components/buttons/Button';
import LineChart from '../../components/charts/LineChart';

const AlarmsChartWrapper = styled.div`
  .alarmchart {
    &__controls {
      button {
        margin-left: ${getTheme('spacer', 's')};
      }
    }
  }

  .noresults {
    text-align: center;
    &__icon {
      color: ${getTheme('textColor', 'baseLight')};
      font-size: ${getTheme('fontSize', 'display')};
    }
    &__heading {
      font-weight: 300;
      color: ${getTheme('textColor', 'altLight')};
    }
    &__text {
      font-size: ${getTheme('fontSize', 'note')};
      font-weight: 600;
    }
  }
`;

class AlarmsChart extends Component {
  render() {
    return (
      <AlarmsChartWrapper>
        <CardFile
          cardTitle={this.props.cardTitle}
          hasControls={true}
          noResults={this.props.noResults}
          cardControls={
            <div className="alarmchart__controls">
              <Button
                size="xsmall"
                noMarginBottom
                secondary
                onClick={this.props.handleEdit}
                iconBefore={<FontAwesomeIcon icon={faPencil} />}
              >
                Edit
              </Button>
              <Button
                size="xsmall"
                noMarginBottom
                secondaryWarning
                onClick={this.props.handleRemove}
                iconBefore={<FontAwesomeIcon icon={faTrashAlt} />}
              >
                Delete
              </Button>
            </div>
          }
        >
          {this.props.vars.length === 0 && (
            <div className="noresults">
              <div className="noresults__icon">
                <FontAwesomeIcon icon={faChartLine} />
              </div>
              <Heading level="heading2">
                <h3 className="noresults__heading">There are no variable charts yet</h3>
              </Heading>
            </div>
          )}

          {this.props.vars.length > 0 && (
            <LineChart chartData={this.props.variablesValues} chart_loading={this.props.chart_loading} />
          )}
        </CardFile>
      </AlarmsChartWrapper>
    );
  }
}

export default AlarmsChart;



// WEBPACK FOOTER //
// ./src/pages/alarms/AlarmsChart.js